import axios from "./axios-wrapper";

export const getAllNetworks = async () => {
    const response = await axios.get("/network/");
    return response.data;
}